import { __spreadArray } from '../../_virtual/_tslib.js';
import { defineComponent } from '@vue/composition-api';

var script = defineComponent({
    name: 'SdsTransition',
    props: {
        name: {
            type: String,
            required: false,
            default: 'fade',
        },
        mode: {
            type: String,
            required: false,
            default: undefined,
        },
        appear: {
            type: Boolean,
            required: false,
            default: false,
        },
        skipTransition: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: [
        'beforeEnter',
        'enter',
        'afterEnter',
        'enterCancelled',
        'beforeLeave',
        'leave',
        'afterLeave',
        'leaveCancelled',
    ],
    setup: function (_, _a) {
        var emit = _a.emit;
        var JSHooks = {
            beforeEnter: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                emit.apply(void 0, __spreadArray(['beforeEnter'], args, false));
            },
            enter: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                emit.apply(void 0, __spreadArray(['enter'], args, false));
            },
            afterEnter: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                emit.apply(void 0, __spreadArray(['afterEnter'], args, false));
            },
            enterCancelled: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                emit.apply(void 0, __spreadArray(['enterCancelled'], args, false));
            },
            beforeLeave: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                emit.apply(void 0, __spreadArray(['beforeLeave'], args, false));
            },
            leave: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                emit.apply(void 0, __spreadArray(['leave'], args, false));
            },
            afterLeave: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                emit.apply(void 0, __spreadArray(['afterLeave'], args, false));
            },
            leaveCancelled: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                emit.apply(void 0, __spreadArray(['leaveCancelled'], args, false));
            },
        };
        return {
            JSHooks: JSHooks,
        };
    },
});

export default script;
